<template>
  <div :class="['wrapper', { 'wrapper__paddingless': !!this.mode }]">
    <div
      v-if="this.floorsPlan?.length"
      v-for="floor in this.floorsPlan"
      :key="floor.floor_map_id"
      class="floor"
    >
      <CustomCheckbox
        v-if="this.showCheckbox(floor)"
        :value="floor?.is_selected"
        @change="(value) => onCheckboxChange(floor, value)"
        :small="true"
      />
      <div
        v-else-if="this.mode === 'flat-grouping' || this.mode === 'floor-grouping'"
        style="width: 30px;"
      ></div>
      <span class="floorNum">{{ floor.floor }}</span>
      <div class="apartments">
        <div
          v-for="apartment in floor.flat"
          :key="apartment.flat_id"
          :class="['apartment', { apartment__small: !!this.mode, apartment__cursorPointer: !this.mode }]"
          @click="() => this.onApartmentClick && this.onApartmentClick({...apartment, floor: floor.floor, floor_map_id: floor.floor_map_id, colour_id: floor.colour_id }, )"
          :style="`background-color: ${this.getCellColor(floor, apartment)}`"
        >
          <q-tooltip anchor="center middle">
            <p v-if="apartment.remont_id" style="margin: 0; font-size: 13px;">
              remont_id = {{ apartment.remont_id }}
            </p>
            <p v-if="apartment.flat_id" style="margin: 0; font-size: 13px;">
              flat_id = {{ apartment.flat_id }}
            </p>
          </q-tooltip>
          <span class="apartmentRoomCnt">
            {{ apartment.room_cnt }}
          </span>
          <span class="apartmentInfo">{{ apartment.area }} м²</span>
          <span class="apartmentInfo">кв. {{ apartment.flat_num }}</span>
          <span
            v-if="!!apartment.remont_id"
            class="apartmentInfo"
            style="font-size: 11px;"
          >
            #{{ apartment.remont_id }}</span
          >
        </div>
      </div>
      <div v-if="!!this.getFloorData" style="font-weight: 500;">
        <q-tooltip> Контрольная сумма </q-tooltip>
        {{ this.getFloorData(floor.floor) }}
      </div>
      <q-btn
        v-if="!this.mode"
        size="sm"
        padding="xs"
        style="flex-shrink: 0;"
        @click="() => this.handleCreateRemont(floor.floor)"
        :loading="!!this.creatingRemont[floor.floor]"
      >
        <q-icon name="fas fa-play" style="font-size: 14px; color: #1976d2" />
        <q-tooltip>Создание или пересчет сметы</q-tooltip>
      </q-btn>
      <CustomSelect
        v-if="this.mode === 'grouping' && !!floor.floor_map_id"
        :options="this.colors"
        label="Группа"
        style="width: 100px;"
        optionValueKey="colour_id"
        optionLabelKey="label"
        :value="floor.colour_id"
        @change="value => this.onGroupChange(value, floor.floor_map_id, floor.floor)"
        :clearable="false"
        :colorMode="true"
      />
    </div>
    <NotFoundText
      v-else-if="!this.isFetching"
      :text="this.show ? 'Нет данных' : 'Заполните данные'"
    />
  </div>
</template>

<script>
import CustomCheckbox from "@/components/form/CustomCheckbox";
import CustomSelect from "@/components/form/CustomSelect";
import NotFoundText from "@/components/common/NotFoundText";
import { changeFloorGroup, getEntranceColors, checkFlatFloor } from "./services";
import { hexToRgba } from "@/services";
import { appActions } from "@/services/store/modules/app_module/app_actions";
import { MODAL_NAMES } from "@/constants";

export default {
  name: 'ResidentialApartmentsList',
  components: {CustomCheckbox, CustomSelect, NotFoundText},
  props: ['onApartmentClick', 'floorsPlan', 'mode', 'updateData', 'params', 'addData', 'getFloorData', 'isFetching', 'show', 'createRemont'],
  data() {
    return {
      loading: {},
      creatingRemont: {},
      colors: [],
    };
  },
  methods: {
    hexToRgba,
    async onGroupChange(colour_id, floor_map_id, floor) {
      if(this.loading[floor]) return
      const body = {
        is_new_group: colour_id === 'new_group',
        floor_map_id,
        colour_id: colour_id === 'new_group' ? null : colour_id
      }
      this.loading[floor] = true
      const res = await changeFloorGroup(body, this.params)
      this.loading[floor] = false
      if(!res) return
      this.updateData && this.updateData(res)
      this.getColors()
    },
    async handleCreateRemont(floor) {
      this.$store.commit(appActions.showModal(MODAL_NAMES.CREATE_FLOOR_REMONT, {
        title: 'Создание или пересчет сметы',
        onSubmit: async (body) => {
          this.creatingRemont[floor] = true
          await this.createRemont({...body, floor})
          this.creatingRemont[floor] = false
        }
      }));
    },
    async getColors() {
      if(this.mode !== 'grouping') return
      const res = await getEntranceColors(this?.params)
      if(!res) return
      this.colors = res
    },
    showCheckbox(floor) {
      if(this.mode !== 'flat-grouping' && this.mode !== 'floor-grouping') return false
      const {floor_map_id, colour_id} = floor

      if(this.mode === 'flat-grouping') {
        if(!floor_map_id || colour_id !== this.addData?.colour_id)
          return false
      }
      if(this.mode === 'floor-grouping') {
        if(!floor_map_id) return true
        if(colour_id !== this.addData?.colour_id) return false
      }
      return true
    },
    onCheckboxChange(floor, value) {
      const {floor_map_id, floor: key} = floor
      if(this.params.floor_map_id === floor_map_id) return
      const updatedData = this.floorsPlan.map(floor => {
        if (floor.floor === key) {
          return { ...floor, is_selected: value };
        }
        return floor;
      });
      this.updateData(updatedData)
    },
    getCellColor(floor, apartment) {
      if(this.mode !== 'flat-grouping') return hexToRgba(floor.hex_code, .5)
      return checkFlatFloor(floor, apartment, this.addData) ? 'rgba(173 ,102 ,255, .5)' : hexToRgba(floor.hex_code, .5)
    }
  },
  mounted() {
    this.getColors()
  }
};
</script>

<style scoped lang="scss">
.wrapper {
  padding: 20px;

  &__paddingless {
    padding: 0;
  }
}
.floor {
  margin-bottom: 5px; display: flex; gap: 15px; align-items: center;
}
.floorNum {
  font-size: 14px; font-weight: 400; color: #333;
  width: 18px;;
}
.apartments {
  display: flex; gap: 5px; align-items: center;
}
.apartment {
  width: 90px;
  height: 90px; padding: 5px;
  border-radius: 12px;
  background-color: #f0f0f0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: .3s all;

  &:hover {
    background-color: #d2dce3;
  }

  &__cursorPointer {
    cursor: pointer;
  }

  &__small {
    width: 70px;
    height: 70px;
  }
}
.apartmentRoomCnt {
  font-size: 16px;
  font-weight: bold;
  color: #474747;
}
.apartmentInfo {
  font-size: 12px;
  color: #474747;
}
</style>
